import { removeNonNumbers } from '@ott/transforms';

const formatAmountRegEx = /\B(?=(\d{3})+(?!\d))/g;

export const parseAmount = (value: string): string => {
  if (!value) {
    return '';
  }
  return removeNonNumbers(value);
};

export const formatAmount = (value: string, prevValue: string, cursor: number) => {
  if (!value) {
    return { value, cursor };
  }

  const formattedWithoutNumbers: string = removeNonNumbers(value);
  const formattedValue = formattedWithoutNumbers
    ? formattedWithoutNumbers.replace(formatAmountRegEx, ' ')
    : '';

  return { value: formattedValue, cursor: formattedValue.length };
};
